<template>
  <div
    class="xc-loading"
    v-if="isShow"
  >
    <div class="xc-loading-box">
      <div class="xc-loading-spinner xc-loading-lds-dual-ring"></div>
      <div class="xc-loading-text">{{typeof text == 'string' ?text:'请求中……'}}</div>
    </div>
  </div>
</template>


<script>
export default {
  name: 'XcLoading',
  props: {
    text: null,
    time: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isShow: true,
    }
  },
  methods: {
    close() {
      this.isShow = false;
    },
  },
  created() {
    if (this.time) {
      setTimeout(() => {
        this.close();
      }, this.time);
    }
  },

}
</script>

<style scoped lang="scss">
</style>

